import { c as _c } from "react/compiler-runtime";
import type { GetHistoryFilters } from '@repo/schema/history';
import { Button, Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components';
import { Check, ChevronDown } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { KitAvatar } from '../../avatar/avatar.tsx';
type HistoryUserFilterProps = {
  onUserChange: (_userId: number | undefined) => void;
  userId?: number;
  users: GetHistoryFilters['users'];
};
const getUserLabel = (user: GetHistoryFilters['users'][number]) => `${user.name}${user.last_name ? ` ${user.last_name}` : ''}`;
export const HistoryUserFilter = t0 => {
  const $ = _c(52);
  const {
    onUserChange,
    userId,
    users
  } = t0;
  let T0;
  let T1;
  let T2;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== userId || $[1] !== users) {
    let t13;
    if ($[17] !== userId) {
      t13 = user => user.id === userId;
      $[17] = userId;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    const selectedUser = users.find(t13);
    T2 = Popover;
    t10 = "Popover";
    t11 = "HistoryUserFilter";
    t12 = "history-user-filter.tsx";
    T1 = PopoverTrigger;
    t7 = true;
    t8 = "PopoverTrigger";
    t9 = "history-user-filter.tsx";
    T0 = Button;
    t1 = "Changed by";
    t2 = "w-full justify-between @xl/card-header:w-[120px]";
    t3 = "outline";
    t4 = "Button";
    t5 = "history-user-filter.tsx";
    t6 = selectedUser ? <span className="flex min-w-0 items-center gap-2 truncate"><KitAvatar alt={getUserLabel(selectedUser)} size="sm" user={selectedUser} /><span className="truncate">{getUserLabel(selectedUser)}</span></span> : <span>Changed by</span>;
    $[0] = userId;
    $[1] = users;
    $[2] = T0;
    $[3] = T1;
    $[4] = T2;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    T0 = $[2];
    T1 = $[3];
    T2 = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChevronDown aria-hidden="true" className="size-4 shrink-0 opacity-50" data-sentry-element="ChevronDown" data-sentry-source-file="history-user-filter.tsx" />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== T0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t14 = <T0 aria-label={t1} className={t2} variant={t3} data-sentry-element={t4} data-sentry-source-file={t5}>{t6}{t13}</T0>;
    $[20] = T0;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== T1 || $[29] !== t14 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t15 = <T1 asChild={t7} data-sentry-element={t8} data-sentry-source-file={t9}>{t14}</T1>;
    $[28] = T1;
    $[29] = t14;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <CommandInput placeholder="Search users" data-sentry-element="CommandInput" data-sentry-source-file="history-user-filter.tsx" />;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <CommandEmpty data-sentry-element="CommandEmpty" data-sentry-source-file="history-user-filter.tsx">No results found</CommandEmpty>;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== onUserChange || $[37] !== userId || $[38] !== users) {
    let t19;
    if ($[40] !== onUserChange || $[41] !== userId) {
      t19 = user_0 => <CommandItem key={user_0.id} onSelect={() => onUserChange(user_0.id === userId ? undefined : user_0.id)} value={`${getUserLabel(user_0)} ${user_0.email} ${user_0.id}`}><Check aria-hidden="true" className={cn("mr-2 size-4", user_0.id === userId ? "opacity-100" : "opacity-0")} /><KitAvatar alt={getUserLabel(user_0)} size="sm" user={user_0} /><span className="truncate">{getUserLabel(user_0)}</span></CommandItem>;
      $[40] = onUserChange;
      $[41] = userId;
      $[42] = t19;
    } else {
      t19 = $[42];
    }
    t18 = users.map(t19);
    $[36] = onUserChange;
    $[37] = userId;
    $[38] = users;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[43] !== t18) {
    t19 = <PopoverContent align="start" className="w-[240px] p-0" data-sentry-element="PopoverContent" data-sentry-source-file="history-user-filter.tsx"><Command data-sentry-element="Command" data-sentry-source-file="history-user-filter.tsx">{t16}<CommandList data-sentry-element="CommandList" data-sentry-source-file="history-user-filter.tsx">{t17}<CommandGroup data-sentry-element="CommandGroup" data-sentry-source-file="history-user-filter.tsx">{t18}</CommandGroup></CommandList></Command></PopoverContent>;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== T2 || $[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t15 || $[50] !== t19) {
    t20 = <T2 data-sentry-element={t10} data-sentry-component={t11} data-sentry-source-file={t12}>{t15}{t19}</T2>;
    $[45] = T2;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
    $[49] = t15;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  return t20;
};